import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {BLUE_LIGHT} from 'ui-library/Colors';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export default function ChecklistPanelLink(props: {
  displayText: string;
  onClick: () => void;
  icon?: BenchlingIconName;
}): JSX.Element {
  return (
    <div className={classNames(css(styles.checklistPanelLink), css(styles.newFont))} onClick={props.onClick}>
      {props.displayText}
      <BenchlingIcon icon={props.icon ?? 'open'} className={classNames('pull-right', css(styles.icon))} />
    </div>
  );
}

const styles = StyleSheet.create({
  checklistPanelLink: {
    backgroundColor: BLUE_LIGHT,
    borderRadius: '4px',
    cursor: 'pointer',
    lineHeight: '24px',
    padding: '12px',
    marginTop: '12px',
  },
  font: {
    fontSize: '15px',
    fontWeight: 600,
  },
  newFont: {
    fontSize: '16px',
  },
  icon: {
    marginTop: '4px',
  },
});
